import React from "react";
import { Tooltip, IconButton, Typography, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const InformacionProteccionDatos = () => {
  return (
    <Box display="flex" alignItems="center" gap={1} mt={2}>
      <InfoOutlinedIcon color="primary" />
      <Tooltip
        title={
          <span style={{ whiteSpace: "pre-line", fontSize: "0.85rem" }}>
            <strong>INFORMACIÓN PROTECCIÓN DE DATOS DE COLEGIO DE ENFERMERÍA DE VALLADOLID</strong>, con CIF nº Q4766004H y domicilio en C/ Alcalleres nº5, 1º, 47001 Valladolid e Inscrito en el Registro de Colegios Profesionales de Castilla y León, mediante ORDEN de 6 de abril de 2001, de la Consejería de Presidencia y Administración Territorial.
            {"\n\n"}
            <strong>Finalidades:</strong> Responder a sus solicitudes y remitirle información comercial de nuestros productos y servicios, incluso por medios electrónicos.
            {"\n"}
            <strong>Legitimación:</strong> Consentimiento del interesado.
            {"\n"}
            <strong>Destinatarios:</strong> No están previstas cesiones de datos.
            {"\n"}
            <strong>Derechos:</strong> Puede retirar su consentimiento en cualquier momento, así como acceder, rectificar, suprimir sus datos y demás derechos en{" "}
            <a href="mailto:enfermeriavalladolid@delegado-datos.com" style={{ color: "#ffffffff" }}>
              enfermeriavalladolid@delegado-datos.com
            </a>.
            {"\n"}
            <strong>Información Adicional:</strong> Puede ampliar la información en el enlace de{" "}
            <a href="/aviso-legal" target="_blank" rel="noopener noreferrer" style={{ color: "#ffffffff" }}>
              Aviso legal
            </a>.
          </span>
        }
        arrow
        placement="right"
      >
        <Typography variant="body2" sx={{ textDecoration: "underline", cursor: "pointer" }}>
          INFORMACIÓN PROTECCIÓN DE DATOS
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default InformacionProteccionDatos;
